import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { Input } from '@/shared/ui/input/input';
import { PlusIcon } from 'lucide-react';
import { ChangeEvent, useState } from 'react';
import styles from './add-section-button.module.css';

const { addSections } = useConfigurator.getState();

export const AddSectionButton = () => {
	const [value, setValue] = useState<string>('');

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value.replace(' ', '');

		if (value.includes('.') || value.includes(',') || value.includes('-')) {
			return;
		}

		if (!value.trim().length) {
			setValue('');
			return;
		}

		if (Number.isNaN(+value) || !Number.isInteger(+value)) {
			return;
		}

		if (+value < 1) {
			setValue('0');
			return;
		}

		setValue((+value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
	};

	return (
		<div className={styles.wrapper}>
			<button className={styles.button} onClick={() => addSections(Math.max(+value, 1))}>
				<PlusIcon size={20} color="white" />
			</button>
			<Input value={value} className={styles.input} onChange={handleChange} />
		</div>
	);
};
